import React from 'react';
import {defaultTemplate} from 'core/hoc';
import { BasicCheckbox, BaasicButton, IconCheckbox } from 'core/components';
import { toDate, isNikoFlowTask } from 'core/utils';
import _ from 'lodash';

const TasksCardTemplate = defaultTemplate(({ title, store, onClick, t }) => {
    const { tasks, rootStore, onChange, disableCheckboxes, openFacilityEdit, openPickTicketEdit, downloadDeliveryTicketNiko, reminder } = store;
    let sections = [];

  _.each(tasks, (groupItems, groupDate) => {
    let rows = groupItems.map(task =>

        <React.Fragment key={task.id}> 
            <tr>
                <td>
                    {task.facility &&
                    <React.Fragment>
                        <div className="row" style={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
                            <div className="form__group col col-lrg-11">
                                <strong><a onClick={() => openFacilityEdit(task.facility.id)}>{task.name}</a> </strong>
                                {
                                  task && !isNikoFlowTask(task.facility, task.dateOfService) && task.facilityOrder && task.facilityOrder.pickTicketHeaderId && task.facilityOrder.sendOrder &&
                                  <strong> - <a onClick={() => openPickTicketEdit(task.facilityOrder, task.facilityOrder.pickTicketHeaderId)}> Pick Ticket</a></strong>
                                }
                                {
                                  task && isNikoFlowTask(task.facility, task.dateOfService) && task.facilityOrderId && task.facilityOrder && task.facilityOrder.sendOrder &&
                                  <strong> - <a onClick={() => downloadDeliveryTicketNiko(task.facilityOrderId)}> Delivery Ticket</a></strong>
                                }
                            </div>
                            {reminder && task[reminder] && <div className="form__group col col-lrg-1 type--right">
                                <IconCheckbox
                                    checked={task[reminder]}
                                    onChange={(checked) => onChange(reminder, checked, task) }
                                    checkedIconClass="u-icon--flag--red"
                                    unCheckedIconClass="u-icon--flag"
                                />
                            </div>}
                        </div>
                        <div>
                            {task.facility.notes && <div className="table--has-note">
                                <i className="u-icon u-icon--sml u-icon--note u-icon--text-top"></i>
                                <span className="table__note">{task.facility.notes}</span>
                            </div> }
                        </div>
                    </React.Fragment>}
                    <div>
                        {task.notes && <div className="table--has-note">
                            <i className="u-icon u-icon--sml u-icon--note u-icon--text-top"></i>
                            <span className="table__note">{task.notes}</span>
                        </div> }
                    </div>
                    {rootStore.userStore.user && 
                    <div className="row u-mar--top--sml">
                        <div className="form__group col col-lrg-11">
                            <div className="row">
                                <div className="col" title={task.intakeRep != null ? task.intakeRep.firstName + " " + task.intakeRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-3">
                                            <BasicCheckbox id={task.id + "isDoneIntake"} checked={task.isDoneIntake}
                                                disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                                !(task.intakeRep != null && rootStore.userStore.user.id == task.intakeRep.userId)) || 
                                                disableCheckboxes} 
                                                onChange={(e) => onChange("isDoneIntake", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-9">
                                            <div className={`row ${!task.isDoneIntakeDate ? 'u-padd--left--tny' :''}`}>{t('DASHBOARD.EDIT_ORDER.IS_INTAKE_LABEL')} 
                                                {task.intakeRep != null && task.intakeRep.initials != null && " (" + task.intakeRep.initials + ")"}
                                            </div>
                                            {task.isDoneIntakeDate && <sub className="row">[{toDate(task.isDoneIntakeDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>
                                {task.facility && (task.facility.partBOnly || task.facility.requiredSecondPayor || (task.facility.corporate_ != null && task.facility.corporate_.requiredSecondPayor)) &&
                                <div className="col" title={task.intakeRep != null ? task.intakeRep.firstName + " " + task.intakeRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-2">
                                            <BasicCheckbox id={task.id + "productInfoNeeded"} checked={task.productInfoNeeded}
                                                disabled={
                                                task.productInfoNeeded ||
                                                disableCheckboxes} 
                                                onChange={(e) => onChange("productInfoNeeded", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-10">
                                            <div className={`row`}>Product Info Needed 
                                                {task.intakeRep != null && task.intakeRep.initials != null && " (" + task.intakeRep.initials + ")"}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col" title={task.payorRep != null ? task.payorRep.firstName + " " + task.payorRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-2">
                                            <BasicCheckbox id={task.id + "isDonePayor"} checked={task.isDonePayor}
                                                disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                                !(task.payorRep != null && rootStore.userStore.user.id == task.payorRep.userId)) ||
                                                disableCheckboxes}  
                                                onChange={(e) => onChange("isDonePayor", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-10">
                                            <div className={`row`}>{t('DASHBOARD.EDIT_ORDER.IS_PAYOR_LABEL')}
                                                {task.payorRep != null && task.payorRep.initials != null && " (" + task.payorRep.initials + ")"}
                                            </div>
                                            {task.isDonePayorDate && <sub className="row">[{toDate(task.isDonePayorDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col" title={task.documentRep != null ? task.documentRep.firstName + " " + task.documentRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-2">
                                        <BasicCheckbox id={task.id + "isDoneDocument"} checked={task.isDoneDocument}
                                            disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                            !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                            !(task.documentRep != null && rootStore.userStore.user.id == task.documentRep.userId)) || 
                                            disableCheckboxes}  
                                            onChange={(e) => onChange("isDoneDocument", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-10 u-padd--left--sml">
                                            <div className='row'>{t('DASHBOARD.EDIT_ORDER.IS_DOCUMENT_LABEL')}
                                            {task.documentRep != null && task.documentRep.initials != null && " (" + task.documentRep.initials + ")"}
                                            </div>
                                            {task.isDoneDocumentDate && <sub className="row">[{toDate(task.isDoneDocumentDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>
                                {task.isCoverageTypeAll &&
                                <div className="col" title={task.intakeRep != null ? task.intakeRep.firstName + " " + task.intakeRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-3">
                                            <BasicCheckbox id={task.id + "isInventoryDone"} checked={task.isInventoryDone}
                                                disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                                !(task.intakeRep != null && rootStore.userStore.user.id == task.intakeRep.userId)) ||
                                                !task.isDoneIntake ||
                                                disableCheckboxes} 
                                                onChange={(e) => onChange("isInventoryDone", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-9">
                                            <div className={`row`}>Inventory 
                                                {task.intakeRep != null && task.intakeRep.initials != null && " (" + task.intakeRep.initials + ")"}
                                            </div>
                                            {task.isInventoryDoneDate && <sub className="row">[{toDate(task.isInventoryDoneDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>}
                                {task.facility && (task.facility.partBOnly || task.facility.requiredSecondPayor || (task.facility.corporate_ != null && task.facility.corporate_.requiredSecondPayor)) &&
                                <div className="col" title={task.payorRep != null ? task.payorRep.firstName + " " + task.payorRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-2">
                                            <BasicCheckbox id={task.id + "isSecondCheckDone"} checked={task.isSecondCheckDone}
                                                disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                                !(task.payorRep != null && rootStore.userStore.user.id == task.payorRep.userId)) ||
                                                !task.isDonePayor ||
                                                disableCheckboxes} 
                                                onChange={(e) => onChange("isSecondCheckDone", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-10 u-padd--left--sml">
                                            <div className='row'>2nd Payor check
                                                {task.payorRep != null && task.payorRep.initials != null && " (" + task.payorRep.initials + ")"}
                                            </div>
                                            {task.isSecondCheckDoneDate && <sub className="row">[{toDate(task.isSecondCheckDoneDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>}
                                <div className="col" title={task.billingRep != null ? task.billingRep.firstName + " " + task.billingRep.lastName : ""}>
                                    <div className="row">
                                        <div className="col col-med-3">
                                            <BasicCheckbox id={task.id + "isDoneBiller"} checked={task.isDoneBiller}
                                                disabled={(!rootStore.permissionStore.hasPermission('calendarSection.update') && 
                                                !(task.accountRep != null && rootStore.userStore.user.id == task.accountRep.userId) && 
                                                !(task.billingRep != null && rootStore.userStore.user.id == task.billingRep.userId)) ||
                                                disableCheckboxes} 
                                                onChange={(e) => onChange("isDoneBiller", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-9 u-padd--left--sml">
                                            <div className='row'>{t('DASHBOARD.EDIT_ORDER.IS_BILLER_LABEL')}
                                                {task.billingRep != null && task.billingRep.initials != null && " (" + task.billingRep.initials + ")"}  
                                            </div>
                                            {task.isDoneBillerDate && <sub className="row">[{toDate(task.isDoneBillerDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col col-med-3">
                                            <BasicCheckbox id={task.id + "sendOrder"} checked={task.sendOrder}
                                                disabled={disableCheckboxes} 
                                                onChange={(e) => onChange("sendOrder", e.target.checked, task) } />
                                        </div>
                                        <div className="col col-med-9 u-padd--left--sml">
                                            <div className='row'>
                                                {t('DASHBOARD.EDIT_ORDER.SEND_ORDER')}
                                            </div>
                                            {task.sendOrderDate && <sub className="row">[{toDate(task.sendOrderDate,true)}]</sub>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form__group col col-lrg-1 type--right">
                            <BaasicButton
                                className="btn btn--icon"
                                icon='u-icon u-icon--edit u-icon--sml'
                                label='FACILITY.LIST.BUTTON.EDIT'
                                onlyIcon={true}
                                onClick={() => onClick(task)}>
                            </BaasicButton>        
                        </div>
                    </div>}
                    <div className="row">
                        <div className="u-mar--top--tny">
                            {task.originalAccountRep  &&
                            <div className="table__tag table__tag--user">
                                <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                                <span>{task.originalAccountRep}</span>
                            </div>
                            }
                            {task.originalIntakeRep  &&
                            <div className="table__tag table__tag--user">
                                <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                                <span>{task.originalIntakeRep}</span>
                            </div>
                            }
                            {task.originalPayorRep  &&
                            <div className="table__tag table__tag--user">
                                <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                                <span>{task.originalPayorRep}</span>
                            </div>
                            }
                            {task.originalDocumentRep  &&
                            <div className="table__tag table__tag--user">
                                <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                                <span>{task.originalDocumentRep}</span>
                            </div>
                            }
                            {task.originalBillingRep  &&
                            <div className="table__tag table__tag--user">
                                <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                                <span>{task.originalBillingRep}</span>
                            </div>
                            }
                            {task.originalDate && <div className="table__tag table__tag--date">
                                <i className="u-icon u-icon--xsml u-icon--schedule-update u-mar--right--tny"></i>
                                <span>{toDate(task.originalDate)}</span>
                            </div>}
                            {task.facility && task.facility.shipPoint >= 2 &&
                              <div className="table__tag table__tag--facility">
                                <span>{task.facility.shipPoint} Ship Point</span>
                            </div>
                            }
                            {task.facility && task.facility.partBOnly &&
                            <div className="table__tag table__tag--facility">
                                <span>Part B Only</span>
                            </div>}
                            {task.facility && task.facility.isNewFacility &&
                            <div className="table__tag table__tag--facility">
                                <i className="u-icon u-icon--xsml u-icon--new-facility u-mar--right--tny"></i>
                                <span>New Facility</span>
                            </div>
                            }
                        </div>
                    </div>
                </td>
            </tr>
        </React.Fragment>);

        let section = rows != null ? <React.Fragment key={tasks.roleTitle + groupDate}>
            <h6 className="form__title form__title--sub form__title--list">{groupDate}</h6>
            <table className="table--tasks2 u-mar--bottom--med">
                <tbody>
                    {rows}
                </tbody>
            </table>
        </React.Fragment> : null;
        sections.push(section);
  });

    return (
        <React.Fragment>
            {sections.length > 0 &&
            <div className="u-display--ib w--100 u-mar--bottom--sml">
            <div className="card card--form card--primary card--med card--flex">
                <h4 className="form__title form__title--preview">{t(title)}</h4>
                 {sections}
            </div>
            </div>}
        </React.Fragment> 
    )
});

export default TasksCardTemplate;